import React, { useEffect, useState } from "react";
import "./LoanCategories.scss";
import { 
    Box, 
    Typography, 
    Button,
} from "@mui/material";
import { commonRunQuery, loansCreateCategory, loansDeleteCategory, loansUpdateCategory } from "../../../util/API/loans";
import CustomLoansForm from "../../../components/UI/CustomLoansForm/CustomLoansForm";
import LoanSetupTable from "../../../components/LoanSetupTable/LoanSetupTable";

const LoanCategories = ({setAlert, setAlertOpen, alert, handleViewCategoryLoanProducts}) => {
    const [categoryName, setCategoryName] = useState("");
    const [categories, setCategories] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [formValues, setFormValues] = useState(null);
    const [createCategory, setCreateCategory] = useState(false);
    const [viewMode, setViewMode] = useState("table"); // 'table' | 'create' | 'edit'
    const [selectedCategory, setSelectedCategory] = useState(null);

    useEffect(()=> {
        getAllCategories();
    }, []);

    const getAllCategories = async() => {
        try {
            const response = await commonRunQuery(265,"");
            if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                const loanCategoriesArray = Array.isArray(response?.data?.body?.record) ? response?.data?.body?.record : [response?.data?.body?.record];
                setCategories(loanCategoriesArray);
                console.log("getAllCategories=======================",loanCategoriesArray);
            } else {
                setCategories([]);
            }
        } catch (error) {
            console.log("getAllCategories_error=======================",error);
        }
    }

    const handleSubmit = async(submittedValue) => {
        if (submittedValue?.categoryname.trim() === "") {
            setAlert({
                showAlert: true,
                message: "Please enter a category name.",
                severity: "error",
                header: "Error",
            });
            return;
        }
        
        console.log("Submitted Category:", submittedValue?.categoryname);

        try {
            const response = await loansCreateCategory(submittedValue?.categoryname);

            if(response?.data?.header?.callStatus === "1") {
                setAlert({
                    showAlert: true,
                    message: "Category created successfully.",
                    severity: "success",
                    header: "Success",
                });
                setAlertOpen(true);

                getAllCategories();
                setViewMode("table");
            }
        } catch (error) {
            setAlert({
                showAlert: true,
                message: "There was an error in creating category. " + error,
                severity: "error",
                header: "Error",
            });
        }
    
        setCategoryName("");
    }

    const handleUpdate = async(submittedValue) => {
        if (submittedValue?.categoryname.trim() === "") {
            setAlert({
                showAlert: true,
                message: "Please enter a category name.",
                severity: "error",
                header: "Error",
            });
            return;
        }
        
        console.log("selectedCategory--------------", selectedCategory?.loancategories?.categoryid);
        console.log("Submitted Category Edit:", submittedValue?.categoryname);
        
        try {
            const response = await loansUpdateCategory(selectedCategory?.loancategories?.categoryid, submittedValue?.categoryname);

            if(response?.data?.header?.callStatus === "1") {
                setAlert({
                    showAlert: true,
                    message: "Category updated successfully.",
                    severity: "success",
                    header: "Success",
                });
                setAlertOpen(true);

                getAllCategories();
                setViewMode("table");
            }
        } catch (error) {
            setAlert({
                showAlert: true,
                message: "There was an error in updating category. " + error,
                severity: "error",
                header: "Error",
            });
        }
    
        setCategoryName("");
    }

    const columns = [
        {
            label: 'Id',
            getValue: (row) => row?.loancategories?.categoryid ?? ''
        },
        {
            label: 'Category Name',
            getValue: (row) => row?.loancategories?.name?.toString().trim() ? row?.loancategories?.name : "-"
        }
    ];

    const handleEdit = async(rowData) => {
        console.log("rowData----------------",rowData);
        setSelectedCategory(rowData);
        setViewMode("edit")
    }

    const handleDeleteConfirmation = (rowData) => {
        setAlert({
            ...alert,
            showAlert: true,
            message: `Are you sure you want to delete ${rowData?.loancategories?.name} category?`,
            severity: "confirm",
            header: "Please Confirm",
            alertType: 'confirm',
            onConfirm: () => handleDelete(rowData)
        })
    }
    
    const handleDelete = async(rowData) => {
        console.log("handleDelete_rowData----------------",rowData);
        try {
            const response = await loansDeleteCategory("", rowData?.loancategories?.categoryid);
            console.log("handleDelete_response----------------",response);

            if(response?.data?.header?.callStatus === "1") {
                setAlert({
                    showAlert: true,
                    message: "Category deleted successfully.",
                    severity: "success",
                    header: "Success",
                });
                setAlertOpen(true);

                getAllCategories();
                setViewMode("table");
            } else if(response?.Status == '2' && response?.payload?.callStatus == '0') {
                setAlert({
                    showAlert: true,
                    message: response?.payload?.msg,
                    severity: "error",
                    header: "Error",
                });
            }
        } catch (error) {
            setAlert({
                showAlert: true,
                message: "There was an error in deleting category. " + error,
                severity: "error",
                header: "Error",
            });
        }
    }

    const handleViewLoanProducts = async(rowData) => {
        console.log("handleViewLoanProducts_handleViewCategoryLoanProducts-----------------",rowData?.loancategories)
        handleViewCategoryLoanProducts(rowData?.loancategories)
    }

    return (
        <Box sx={{ p: 2 }} className="loan-setup-caregories-container">
            {/* CREATE OR EDIT FORM */}
            {(viewMode === "create" || viewMode === "edit") && (
                <>
                    <Box className="d-flex justify-content-between mb-2">
                        <Typography variant="h6" gutterBottom>
                            {viewMode === "create" ? "" : "Edit Loan Category"}
                        </Typography>
                        <Button
                            className="fs-size-12 paiy-blue text-white"
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                setViewMode("table");
                                setSelectedCategory(null);
                            }}
                        >
                            Return
                        </Button>
                    </Box>

                    <Box sx={{ maxWidth: 800, mt: 2, mb: 4 }}>
                        <CustomLoansForm
                            formValues={null}
                            // formValues={viewMode === "edit" ? selectedCategory : null}
                            formName={viewMode === "edit" ? "createloancategory" : "createloancategory"}
                            buttonText={viewMode === "edit" ? "Update" : "Submit"}
                            loadingButtonText={viewMode === "edit" ? "Updating Category ..." : "Creating Category ..."}
                            onSubmit={viewMode === "edit" ? handleUpdate : handleSubmit}
                            initialValues={{
                                categoryname: viewMode === "edit" ? selectedCategory?.loancategories?.name : ""
                            }}
                        />
                    </Box>
                </>
            )}

            {/* TABLE */}
            {viewMode === "table" && (
                <Box>
                    <Box className="d-flex justify-content-between mb-2">
                        <Typography variant="h6" gutterBottom>
                            Loan Categories
                        </Typography>

                        <Button
                            className="fs-size-12 paiy-blue text-white"
                            variant="contained"
                            color="primary"
                            onClick={() => setViewMode("create")}
                        >
                            Create Category
                        </Button>
                    </Box>

                    <LoanSetupTable
                        data={categories}
                        columns={columns}
                        title="Loan Categories"
                        formatRow={(row) => [
                            row?.loancategories?.categoryid,
                            row?.loancategories?.name,
                        ]}
                        isEdit={true}
                        handleEdit={handleEdit}
                        isDelete={true}
                        handleDelete={handleDeleteConfirmation}
                        viewLoanProducts={true}
                        handleViewLoanProducts={handleViewLoanProducts}
                    />
                </Box>
            )}
        </Box>
      );
}

export default LoanCategories;
